(function (angular) {
    'use strict';

    angular
        .module('app.benefit-info')
        .controller('app.benefit-info.controller', ['$scope', '$http', benefitInfoController]);

    function benefitInfoController($scope, $http) {
        // $scope.privacyPolicyHtml = '';
    }
})(angular);
